import React from 'react';
import { Link } from 'react-router-dom';

/** Static paths — must match `routeConfig` geo / venueLocations routes (avoids circular import via helpers). */
const geoLinks = [
  { path: '/admin/geo/import', label: 'Geo import' },
  { path: '/admin/locations', label: 'Venue locations' },
  { path: '/admin/geo/countries', label: 'Countries' },
  { path: '/admin/geo/regions', label: 'Regions' },
  { path: '/admin/geo/city-regions', label: 'City regions' },
  { path: '/admin/geo/cities', label: 'Cities' },
  { path: '/admin/geo/areas', label: 'Areas' },
  { path: '/admin/geo/neighbourhoods', label: 'Neighbourhoods' },
];

const navLinkClass =
  'block px-2 py-1 rounded hover:bg-gray-800 transition';

const GeoNavSection = () => (
  <div className="pt-3 mt-3 border-t border-gray-700 space-y-1">
    <p className="block px-2 py-1 text-gray-400">Geo</p>
    {geoLinks.map((item) => (
      <Link key={item.path} to={item.path} className={navLinkClass}>
        {item.label}
      </Link>
    ))}
  </div>
);

export default GeoNavSection;
